<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.' + $route.name)"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 my-lg-16 py-10 px-3">
      <v-row>
        <v-col
          cols="12"
          lg="3"
          class="min-height"
          :class="{ 'd-none d-lg-flex flex-column': department }"
        >
          <v-row
            v-for="(item, index) in departments"
            :key="index"
            class="mx-0 py-lg-3 justify-center justify-lg-start"
            :class="{ 'py-4 py-lg-0': !department }"
          >
            <v-btn
              class="elevation-0 text-left text-navy font-weight-bold"
              :class="{
                'background-green-light text-white': item.slug === department,
                transparent: item.slug !== department,
              }"
              @click="selectDepartment(item)
              "
            >
              {{ item.name }}
            </v-btn></v-row
          >
        </v-col>
        <v-col cols="12" lg="9">
          <v-container class="d-none d-lg-flex flex-column" v-if="!department">
            <v-row>
              <v-col
                cols="12"
                lg="4"
                v-for="(doctor, index) in doctors.slice(0, num)"
                :key="index"
              >
                <v-card class="mx-auto shadow-1 mb-lg-5" max-width="270">
                  <v-img
                    :src="doctor.upload ? doctor.upload.path : '/imagenes/doctor.png'"
                    height="420px"
                    position="top center"
                    class="d-flex align-end"
                  >
                    <v-container class="pa-0">
                      <div
                        class="align-center d-flex flex-column doctors-caption"
                      >
                        <v-card-title
                          class="text-white text-capitalize font-weight-bold"
                        >
                          {{ doctor.name }}
                        </v-card-title>

                       
                      </div>
                    </v-container>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="justify-center py-lg-5">
              <v-btn
                class="
                  btn-first
                  elevation-0
                  text-capitalize text-lg-h6
                  font-weight-bold
                "
                outlined
                @click="loadMore()"
                >{{ $t("areas.btnLoadMore") }}</v-btn
              >
            </v-row>
          </v-container>
          <v-container class="px-7 px-sm-12 px-lg-3" v-if="department && departmentSelected">
            <v-row class="justify-end d-lg-none">
              <v-btn
                class="
                  mx-lg-auto
                  elevation-0
                  rounded-xl
                  background-green-light
                  text-white text-capitalize text-lg-h6
                  font-weight-bold
                "
                outlined
                width="150"
                @click="selectDepartment(null)"
              >
                {{ $t("areas.goBack") }}</v-btn
              >
            </v-row>
            <v-row>
              <v-col cols="12" lg="5">
                <h3
                  class="text-lg-h3 text-h5 text-navy font-weight-bold"
                  v-text="departmentSelected.name"
                ></h3>
                <p
                  class="
                    text-navy
                    font-weight-light
                    text-justify
                    mt-lg-5
                    mr-lg-10
                    mb-16 mb-lg-0
                  "
                  v-text="departmentSelected.description"
                ></p>
              </v-col>
              <v-col cols="12" lg="7">
                <div>
                  <slick
                    ref="slick"
                    :options="slickOptions"
                    v-if="doctorsDepartmentSelected.length > 0"
                    class="text-center department-select"
                  >
                    <v-card
                      class="mx-auto shadow-1 mb-lg-5"
                      max-width="270"
                      v-for="(doctor, index) in doctorsDepartmentSelected"
                      :key="index"
                    >
                      <v-img
                        :src="doctor.upload? doctor.upload.path: '/imagenes/doctor.png'"
                        height="420px"
                        position="top center"
                        class="d-flex align-end"
                      >
                        <v-container class="pa-0">
                          <div
                            class="
                              align-center
                              d-flex
                              flex-column
                              doctors-caption
                            "
                          >
                            <v-card-title
                              class="
                                text-white text-capitalize
                                font-weight-bold
                              "
                            >
                              {{ doctor.name }}
                            </v-card-title>
                          </div>
                        </v-container>
                      </v-img>
                    </v-card>
                  </slick>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <featured-articles class="mt-lg-16"></featured-articles>
    </v-container>
  </v-container>
</template>
<script>
import FeaturedArticles from "../../../components/featuredArticles.vue";
import DepartmentService from "@/services/department";
import DoctorService from "@/services/doctor";

export default {
  name: "DoctorsAndDepartment",
  components: {
    FeaturedArticles,
  },
  data() {
    return {
      num: 9,
      departmentSelected: [],
      slickOptions: {
        infinite: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 1.5,
        cssEase: "linear",

        responsive: [
          {
            breakpoint: 1264,
            settings: {
              centerMode: true,
              centerPadding: "55px",
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: false,
              slidesToShow: 1,
            },
          },
        ],
      },
      departments: [],
      doctors: [],
      department: "",
    };
  },
  async created() {
    this.department = this.$route.query.department;
    this.doctors = await DoctorService.getDoctors();
    this.doctors.sort((a, b) => (a.name > b.name ? 1 : -1));
    if (this.$route.name === "otherAreas") {
      this.departments = await DepartmentService.getSecondayArea();
      this.departments.sort((a, b) => (a.name > b.name ? 1 : -1));
      let departmentsList = this.departments.map((element) => {
        return element.slug;
      });

      this.doctors = departmentsList
        .map((department) => {
          return this.doctors.filter(
            (doctor) => doctor.department_name === department
          );
        })
        .flat();

        this.doctors.sort((a, b) => (a.name > b.name ? 1 : -1));
    } else {
      this.departments = await DepartmentService.getDepartments();
      this.departments.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    if (this.department) {
      this.departmentSelected = this.departments.find(
        (department) => department.slug === this.department
      );
      this.doctors.sort((a, b) => (a.name > b.name ? 1 : -1));
    }
  },
  computed:{
    doctorsDepartmentSelected(){
      return this.departmentSelected ? this.doctors.filter(doctor => doctor.department_id === this.departmentSelected.id) : []; 
    }
  },
  watch: {
    async department(value) {
      this.departmentSelected = this.departments.find(
        (department) => department.slug === value
      );
    },
  },
  methods: {
    loadMore() {
      this.num = this.num + 3;
    },
    selectDepartment(val){
      this.department = null;
      if(val){
        this.$nextTick(() => {
          this.department = val.slug;
          history.pushState(
            {},
            null,
            this.$route.path + '?department=' + encodeURIComponent(val.slug)
          )
        })
      } else {
        history.pushState(
            {},
            null,
            this.$route.path
          )
      }
    }
  },
};
</script>
